import joi from 'joi';
import j2s from 'joi-to-swagger';
import { makeQueryParametersFromJoiObject, type QueryRequestBody } from './query.parameters.from.joi.object';

interface NewDefinitionOptions {
	params?: { [key: string]: string }[];
	requestBody?: QueryRequestBody;
	method: string;
	summary: string;
	description: string;
	tags?: string[];
}

interface ResponsesOptions {
	code: number;
	description: string;
	schema: joi.Schema;
	responseType?: string;
}

export const makeDefinitionFor = (url: string, info: NewDefinitionOptions, allResponses: ResponsesOptions[]) => {
	const responses: Record<number, object> = {};
	allResponses.forEach((res) => {
		responses[res.code] = {
			description: res.description,
			content: {
				// `??` rather than hasOwnProperty: an explicit `responseType: undefined` satisfies hasOwnProperty
				// and used to produce a literal "undefined" content key.
				[res.responseType ?? 'application/json']: {
					schema: j2s(res.schema).swagger,
				},
			},
		};
	});

	const parameters = info.params || [];
	parameters.push({ $ref: '#/components/parameters/ikeRequester' });

	return {
		[url]: {
			parameters,
			[info.method]: {
				summary: info.summary,
				description: info.description,
				...(info.requestBody != null && makeQueryParametersFromJoiObject(info.requestBody)),
				...(info.hasOwnProperty('tags') && { tags: info.tags }),
				responses,
			},
		},
	};
};
